interface Price {
  pricePlanName?: string
  customerGroupId: number
  customerGroupName: string
  validFrom?: string
  validTo?: string
  priceBase: number
  priceMax: number
  pricePerPeriod: number
}

export interface ItemWithMetadata {
  itemID: number
  itemName: string
  itemName2: string
  urlSlug: string
  crossSellingName?: string
  description: string
  priceDescription: string
  showTip: boolean
  isBookable: boolean
  itemType: ItemType
  rootFolderName: string
  rootFolderId: number
  metadata: { [key: string]: any }
  location: Location
  buildingId: number
  image: string
  amount: number
  showPriceTable: boolean
  prices?: Price[]
  addresses: Address[]
  articleNumber: string
  gallery?: { url: string }[]
  materialIcon?: string
  buildingName?: string
  unit: UnitEnum
  tariff: TariffEnum
  itemQuantity: number[]
  priceOnRequest: boolean
  freeAccessory: boolean
}

export enum UnitEnum {
  Auto = 'Auto', AllowManual = 'AllowManual', ManualOnly = 'ManualOnly'
}

export enum TariffEnum {
  Auto = 'Auto', AllowManual = 'AllowManual', ManualOnly = 'ManualOnly'
}

export interface ItemWithBuilding extends ItemWithMetadata {
  building: ItemWithMetadata | undefined
}

export interface Location {
  id: number
  name: string
  street: string
  zipCode: string
  city: string
  gps: {
    latitude: number
    longitude: number
  }
}

export interface Address {
  type: string
  name: string
  function: string
  street: string
  zipCode: string
  city: string
  phone: string
  mail: string
  website: string
  comments: string
}


export enum ItemType {
  Building = 'Building',
  Room = 'Room',
  Accessory = 'Accessory',
  OutdoorFacility = 'OutdoorFacility',
  Folder = 'Folder',
  Service = 'Service',
  Other = 'Other',
  GiftCard = 'GiftCard'
}
